import React from 'react'
import PropTypes from 'prop-types'
import { Box } from 'pcln-design-system'
import { AmenityIcon } from '@pcln/fly-ui-components'

const FormattedIcon = ({ name, inclusion, description, size }) => (
  <Box ml={1} mr={1}>
    <AmenityIcon
      useSentenceText
      allowHorizontalAlignment
      strikeThroughColor={'text.dark'}
      name={name}
      isBrandedFaresVariant
      inclusion={inclusion}
      description={description}
      size={size}
    />
  </Box>
)

FormattedIcon.defaultProps = {
  size: '16',
}

FormattedIcon.propTypes = {
  name: PropTypes.string,
  inclusion: PropTypes.string,
  description: PropTypes.string,
  size: PropTypes.string,
}

export default FormattedIcon
